import Vue from 'vue'
import Vuex from 'vuex'
import sysconfig from './modules/sysconfig'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
    config: state => state.config
  },
  mutations: {
    
  },
  actions: {
  },
  modules: {
    sysconfig
  },
  plugins: [
    // veux持久化配置
    createPersistedState({
      key: 'rabbitstore-client',
      paths: ['sysconfig']
    })
  ]
})
